import { render } from "storyblok-rich-text-react-renderer"
import React from 'react'

const RichText = ({ children, className }) => {
    return <div className={`${className} richtext`}>{render(children)}</div>
}

export default RichText